import type { ReactElement } from 'react';
import { useState } from 'react';

import type { ICardProps } from './card.interface';

export const Card = ({
  direction = 'col',
  children,
  border = false,
  color = 'white',
  spacing = 12,
  square = false,
  overflow = false,
  widthFull = false,
  heightFull = false,
  onClick,
  p = 0,
  enabledHover = false,
  pointer = false,
  className = ''
}: ICardProps): ReactElement => {
  const [isHovered, setIsHovered] = useState(false);
  const createColorCard = (): string => {
    if (color === 'gray') {
      return `${color}-xmain`;
    }
    return `common-${color}`;
  };
  function createDirection(): string {
    if (direction === 'col') {
      return 'co-flex-col';
    }
    return 'co-flex-row';
  }
  function createSpacing(): string {
    return `
            co-p-${p}px
            co-gap-${spacing}px
        `;
  }
  const handleClick = (): void => {
    onClick && onClick();
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={enabledHover ? handleMouseEnter : undefined}
      onMouseLeave={enabledHover ? handleMouseLeave : undefined}
      className={`
                ${createDirection()}
                ${createSpacing()}
                ${overflow ? 'co-overflow-visible' : 'co-overflow-hidden'}
                ${onClick || pointer ? 'co-cursor-pointer' : 'co-cursor-auto'}
                ${
                  enabledHover && isHovered
                    ? 'co-shadow-md co-transition co-ease-in-out co-delay-75'
                    : ''
                }
                co-flex-1
                co-flex
                co-flex-wrap
                co-min-h-40px
                co-border-1
                co-text-common-black
                ${border ? 'co-border-gray-xlight' : 'co-border-transparent'}
                co-border-1
                ${square ? 'co-rounded-0' : 'co-rounded-8px'}
                ${widthFull ? 'co-w-full' : ''}
                ${heightFull ? 'co-h-full' : ''}
                co-bg-${createColorCard()}
                ${className}
            `}
    >
      {children}
    </div>
  );
};
